export class PhoneNumber {
  id: number;
  number: string;
  extension: string;
  phone_type_id: number;
  notes: string;
  position: number;
  contact_id: number;
  include_in_letterhead: boolean = true;
  editing: boolean = false;
  deleting: boolean = false;
  phone_type_name: string;
}
